import React from 'react';

/**
 * PiFilterLinesStroke icon from the stroke style in general category.
 */
interface PiFilterLinesStrokeProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
  className?: string;
  ariaLabel?: string;
}

export default function PiFilterLinesStroke({
  size = 24,
  color,
  className,
  ariaLabel = 'filter-lines icon',
  ...props
}: PiFilterLinesStrokeProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{color: color || "currentColor"}}
      
      role="img"
      aria-label={ariaLabel}
      {...props}
    >
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h8m-5 6h2M4 6h16" fill="none"/>
    </svg>
  );
}
